import { useEffect } from "react"

import { Drawer, Flex, Typography } from "antd"
import { useDispatch, useSelector } from "react-redux"

import Icon from "../../../../../Icon"
import PaymentDetails from "../../../../Referrals/Outsiders/components/PaymentMethodDetailsModal/PaymentDetails"
import { getPayoutMethod } from "../../redux/requestsWithdrawal.thunks"

import "./styles.less"

const { Text } = Typography

const PayoutMethodDrawer = ({ id, close }) => {
  const dispatch = useDispatch()
  const { payoutMethod, payoutMethodsFetching } = useSelector((state) => state.requestsWithdrawal)

  useEffect(() => {
    if (id) {
      dispatch(getPayoutMethod(id))
    }
  }, [id, dispatch])

  return (
    <Drawer
      title={
        <Flex vertical gap={8}>
          <Text className="title">Payment details</Text>
          <Text type="secondary" strong>
            View and manage your payment methods for withdrawals
          </Text>
        </Flex>
      }
      getContainer={() => document.getElementById("main-layout")}
      width={600}
      placement="right"
      closable
      onClose={close}
      open={!!id}
      destroyOnClose={true}
      closeIcon={<Icon type="cross_small" />}
      loading={payoutMethodsFetching}
      styles={{
        content: { borderRadius: "24px" },
        header: { padding: "16px", border: "none" },
        body: { padding: "12px 16px" }
      }}
      rootClassName="drawer-like-modal withdrawal-payment-method-drawer"
    >
      <PaymentDetails paymentMethod={payoutMethod} />
    </Drawer>
  )
}

export default PayoutMethodDrawer
